import React, { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { MessageCircle } from 'lucide-react';
import Button from './ui/Button';
import QuestionLightbox from './QuestionLightbox';

const Layout: React.FC = () => {
  const [isLightboxOpen, setIsLightboxOpen] = React.useState(false);

  return (
    <div className="flex min-h-screen bg-blue-50 font-avenir">
      <Sidebar />
      <div className="flex-1 flex flex-col lg:ml-64">
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-blue-50 p-4 sm:p-6">
          <Outlet />
        </main>
        <Button
          onClick={() => setIsLightboxOpen(true)}
          className="fixed bottom-4 right-4 rounded-full shadow-lg"
          aria-label="Ask a question"
        >
          <MessageCircle size={24} />
        </Button>
        <QuestionLightbox isOpen={isLightboxOpen} onClose={() => setIsLightboxOpen(false)} />
      </div>
    </div>
  );
};

export default Layout;